import { combineReducers } from 'redux';

import card from './card';
import modals from './modals';
import carousel from "./carousel";
import utils from "./utils";
import documents from "./documents";

export default combineReducers({
  card,
  modals,
  carousel,
  utils,
  documents,
});